import { useQuery } from '@tanstack/react-query';

import { getMerchantAdCampaignConfiguration } from 'apis/ad-bookings/api';

import { CampaignsQueryKeys } from '../../campaignsQueryKeys';
import { transformMerchantAdCampaignConfig } from '../utils/transformAdCampaignApiToAdCampaignForm';

const ONE_HOUR_MS = 1000 * 60 * 60;

export const useAdCampaignMerchantConfiguration = ({
  merchantId,
  country,
  enabled,
}: {
  merchantId: string;
  country: Country;
  enabled: boolean;
}) =>
  useQuery(
    CampaignsQueryKeys.ADS.MERCHANT.GET_CAMPAIGN_CONFIG(merchantId, country),
    () => getMerchantAdCampaignConfiguration(),
    {
      refetchOnWindowFocus: false,
      enabled,
      select: data => transformMerchantAdCampaignConfig(data),
      cacheTime: ONE_HOUR_MS,
      staleTime: ONE_HOUR_MS,
    },
  );
